// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalSecurity = {
  securityRiskLockEnabled: "リスクロックを有効化",
  securityRiskLockThreshold: "リスクロックの発動しきい値",
  securityRiskLockMinutes: "リスクロック時間（分）",
  securitySmsEnabled: "SMS 認証を有効化",
  securitySmsScope: "SMS 認証の適用範囲",
  securityOptionDisabled: "無効",
  securityOptionLogin: "ログイン認証",
  securityOptionHighRisk: "高リスク操作",
  securityOptionAdminLogin: "管理者ログイン",
  securityCaptchaEnabled: "画像 CAPTCHA を有効化",
  securityCaptchaFailThreshold: "連続失敗しきい値",
  securityIpPolicyMode: "IP ポリシーモード",
  securityOptionAllowlist: "許可リスト",
  securityOptionBlocklist: "拒否リスト",
  securityIpAllowlist: "IP 許可リスト",
  securityIpBlocklist: "IP 拒否リスト",
  securitySyncHostAllowlist: "同期ドメイン許可リスト",
  securityLoginRateLimit: "ログイン制限（回/分）",
  securityVerificationRateLimit: "認証コード制限（回/分）",
  securityTitle: "セキュリティ方針",
  securitySubtitle:
    "SMS 認証、画像 CAPTCHA、IP 許可/拒否、レート制限、リスク遮断方針を管理します。",
  securityNotice:
    "このページで、SMS 認証、画像 CAPTCHA、IP 許可/拒否、ログイン制限、リスク遮断方針を管理します。",
} as const;
